// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"7a3c3b5f","977":"671981c3"}[chunkId] + ".chunk.js";
};